__turbopack_context__.v({
  "cover": "Container-module__yi0g7a__cover",
  "default": "Container-module__yi0g7a__default",
  "fluid": "Container-module__yi0g7a__fluid",
});
